import React, { ReactNode, useState } from 'react'
import { Box, useTheme, useMediaQuery } from '@mui/material'
import Navbar from './Navbar'
import Sidebar from './Sidebar'
import MobileBottomNav from './MobileBottomNav'


interface LayoutProps {
  children: ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false)

  const handleDrawerToggle = () => {
    setMobileDrawerOpen(!mobileDrawerOpen)
  }

  const handleDrawerClose = () => {
    setMobileDrawerOpen(false)
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Desktop Sidebar - Fixed Position */}
      {!isMobile && <Sidebar />}

      {/* Mobile Drawer */}
      {isMobile && (
        <Sidebar
          variant="temporary"
          open={mobileDrawerOpen}
          onClose={handleDrawerClose}
        />
      )}

      {/* Main Content Area */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          flex: 1,
          ...((!isMobile) && {
            marginLeft: '280px', // Account for fixed sidebar width
          }),
        }}
      >
        <Navbar onMenuClick={handleDrawerToggle} />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: {
              xs: 1.5, // Reduced padding on mobile for more content space
              sm: 2,
              md: 3
            },
            backgroundColor: 'background.default',
            minHeight: 'calc(100vh - 64px)',
            // Better bottom padding calculation for mobile to ensure content visibility
            paddingBottom: isMobile
              ? 'calc(64px + env(safe-area-inset-bottom, 0px) + 80px)' // Bottom nav + safe area + extra space for FAB
              : '24px',
            overflow: 'auto',
            // Smooth scrolling for mobile
            WebkitOverflowScrolling: 'touch',
            // Better mobile touch handling
            touchAction: 'pan-y',
            // Ensure content is never hidden behind bottom navigation
            position: 'relative',
          }}
        >
          {children}
        </Box>
      </Box>

      {isMobile && <MobileBottomNav />}

    </Box>
  )
}

export default Layout